/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 1820206fdf2f
 */

import * as z from "zod";

export type UploadMappingInput = { folder: string; template: string };

export const UploadMappingInput$zodSchema: z.ZodType<UploadMappingInput> = z
  .object({
    folder: z.string().describe("The folder name for the mapping."),
    template: z.string().describe("The template URL."),
  });
